import { useEffect, useRef, useState } from "react";
import { CARGO_KINDS, type CargoKind } from "@frontier/content/risk";

const labels: Record<CargoKind, string> = {
  energy: "Энергия", salvage: "Оборудование", contraband: "Контрабанда",
  battery: "Батареи", rocket: "Ракеты", drone: "Дроны",
};
type Baseline = { identity: string; counts: Record<CargoKind, number> };

/** A confirmed composition change, without attributing it to a particular request. */
export function useCargoChange(cargo: readonly CargoKind[] | undefined, identity: string | undefined, active: boolean): string {
  const previous = useRef<Baseline | null>(null);
  const [notice, setNotice] = useState<{ text: string } | null>(null);
  useEffect(() => {
    if (!active || !identity || !cargo) {
      previous.current = null;
      setNotice(null);
      return;
    }
    const counts: Record<CargoKind, number> = { energy: 0, salvage: 0, contraband: 0, battery: 0, rocket: 0, drone: 0 };
    for (const kind of cargo) counts[kind]++;
    const before = previous.current;
    previous.current = { identity, counts };
    if (!before || before.identity !== identity) { setNotice(null); return; }
    const gains = CARGO_KINDS.flatMap(kind => counts[kind] > before.counts[kind] ? [{ kind, amount: counts[kind] - before.counts[kind] }] : []);
    const decreased = CARGO_KINDS.some(kind => counts[kind] < before.counts[kind]);
    const gain = gains[0];
    if (gain) setNotice({ text: gains.length === 1 && !decreased ? `+${gain.amount} ${labels[gain.kind]}` : "Состав обновлён" });
    else if (decreased) setNotice(null);
  }, [cargo, identity, active]);
  useEffect(() => {
    if (!notice) return;
    const timer = window.setTimeout(() => setNotice(null), 2500);
    return () => window.clearTimeout(timer);
  }, [notice]);
  return notice?.text ?? "";
}
